import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import store from "../../index";

const initialState = {
  Data: {},
  Status: "",
  calStatus: "",
  TreeDatalStatus: "",
  TreeDataloading: false,
  scrumget: [],
  ProjEnqGET: [],
  calendarloading: false,
  calendardata: {},
  calenderEmpRecordID: "",
  EventStatus: "",
  EventCalendarloading: false,
  EventCalendarData: {},
  EventNotificationStatus: "",
  EventNotificationloading: false,
  EventNotificationData: {},
  EventCalendarEmpRecordID: "",
  msg: "",
  loading: false,
  getLoading: false,
  error: "",
  Successflag: false,
  stockValue: {},
  TreeData: [],
  // AttendanceEntryrow:[],
  stockReqData: {},
  inviceEData: {},
  postLoading: false,
  conversionData: {},
  userGroup: [],
  materialStockData: {},
  exploreData: {},
  trackingData: [],
  customerData: {},
  productanalysisData: {},
  pakingListCarton: [],
  summeryData: [],
  hashtokenData: {},
  costingLeatherCost: {
    materialCost: 0,
    leatherOneCost: 0,
    leatherTwoCost: 0,
    leatherThreeCost: 0,
  },
  customerLeatherData: {},
  summaryData: {},
  deploymentData: {},
  ResignationGetData: {},
  trackingLoading: false,
  materialTrackingData: {
    Rateseries: {},
    Qtyseries: {},
    Amountseries: {},
    categories: [],
    TableData: { data: [] },
  },
  stockorderData: {},
  matrialDcTrackData: [],
  checkInOutData: {},
  LeaveEntryData: {},
  MovementsData: [],
  AttendanceData: [],
  empinvoicedata: [],
  MonthlyAttendanceData: {},
  AttendanceMonthlyloading: false,
 AttendanceDailyloading: false,
  empinvoiceMonthlyloading: false,
  empAttendanceData: [],
  empAttendanceDataLoading: false,
  // InvoicegenerateData: [],
  repaymentget: [],
  repaymentgetLoading: false,
  RepaymentHDgetDataLoading: false,
  RepaymentHDgetData: [],
  RepaymentHDgetHeader: [],
  InvoiceHeaderData: [],
  InvoiceDetailData: [],
  SprintHeaderData: [],
  SprintDetailData: [],
  HeaderData: [],
  DetailData: [],
  timeSheetData: [],
  timeSheetLoading: false,
  PSRStatus: "",
  PSRLoading: false,
  PSRData: [],
  PSRempTaskData: [],
  PSRprojectTaskData: [],

  RegGetData: {},
  SpotGetData: [],
  MeasureGetData: [],
  routinegetstatus: "",
  routineget: {},
  routinePPget: [],
  routineloading: false,
  approvalList: [],


  filterGetData: {},
  filterGetStatus: 'idle',
  filterGetLoading: false,

  SkilGlowAnswerGetData: [],
  SkilGlowAnswerGetStatus: 'idle',
  SkilGlowAnswerGetLoading: false,

  AssessmentVerifyGetData: [],
  AssessmentVerifyGetStatus: 'idle',
  AssessmentVerifyGetLoading: false,

  AssessmentVerifyPostData: {},
  AssessmentVerifyPostStatus: 'idle',
  AssessmentVerifyPostLoading: false,

  EmergencyNotificationPostData: {},
  EmergencyNotificationPostStatus: 'idle',
  EmergencyNotificationPostLoading: false,


  AssessmentEvaluateData: {},
  AssessmentEvaluateStatus: 'idle',
  AssessmentEvaluateLoading: false,

  DVLeaveApprovalData: {},
  DVLeaveApprovalStatus: 'idle',
  DVLeaveApprovalLoading: false,

  SkilGlowAppraisalGetData: [],
  SkilGlowAppraisalGetStatus: 'idle',
  SkilGlowAppraisalGetLoading: false,

  //MONTHLY ATTENDANCE
  EmpMonthlyInvoiceData: {},
  EmpMonthlyInvoiceStatus: 'idle',
  EmpMonthlyInvoiceLoading: false,

  //PROJECT REPORT - PIE CHART
  ProjectStatusReportData: {},
  ProjectStatusReportStatus: 'idle',
  ProjectStatusReportLoading: false,

  //PROJECT REPORT - BAR CHART
  PSRBarChartData: {},
  PSRBarChartStatus: 'idle',
  PSRBarChartLoading: false,

  //HOMEWORK_TEACHER_GET
  HWteachdata: {},
  HWteachstatus: 'idle',
  HWteachloading: false,
  //HOMEWORK_EVALUATION_GET
  HWevaldata: {},
  HWevalstatus: 'idle',
  HWevalloading: false,
  //HOMEWORK_ANALYTICS_GET
  HWAnalyticsdata: {},
  HWAnalyticsstatus: 'idle',
  HWAnalyticsloading: false,
  //ProductCosting - BAR CHART
  ProductCostingData: {},
  ProductCostingStatus: 'idle',
  ProductCostingLoading: false,

  //Costing Overview - BAR CHART
  CostOverviewData: {},
  CostOverviewStatus: 'idle',
  CostOverviewLoading: false,

  //Cost Trend - BAR CHART
  CostTrendData: {},
  CostTrendStatus: 'idle',
  CostTrendLoading: false,

  //Employee Overrun - BAR CHART
  EmployeeOverrunData: {},
  EmployeeOverrunStatus: 'idle',
  EmployeeOverrunLoading: false,

  //Project Manager Dashboard - CHART
  ProjectManagerDashboardData: {},
  ProjectManagerDashboardStatus: 'idle',
  ProjectManagerDashboardLoading: false,

  //DesignationGet - 1st GRID
  DesignationGetData: [],
  DesignationGetStatus: 'idle',
  DesignationGetLoading: false,

  //TotalHrsOccupiedHrsGet - 2nd GRID
  TotalHrsOccupiedHrsGetData: [],
  TotalHrsOccupiedHrsGetStatus: 'idle',
  TotalHrsOccupiedHrsGetLoading: false,

  //ProjectSplitupHrsList - 3rd GRID
  ProjectSplitupHrsListData: [],
  ProjectSplitupHrsListStatus: 'idle',
  ProjectSplitupHrsListLoading: false,

  //EmployeeMapController - CRUD
  EmployeeMapControllerData: {},
  EmployeeMapControllerStatus: 'idle',
  EmployeeMapControllerLoading: false,

  //EmployeeAddController - 4th GRID
  EmployeeAddControllerData: {},
  EmployeeAddControllerStatus: 'idle',
  EmployeeAddControllerLoading: false,
    //PAYSLIP
  paySlipdata: [],
  paySlipstatus: "",
  paySliploading: false,

  //Teacher_get
  TeachergetData: [],
  TeachergetLoading: false,
    //Teacher_invoice_get
  TeachinvoicegetData: [],
  TeachinvoiceLoading: false,
  Teachinvoicestatus: "",

};

export const AssessmentAnswerGet = createAsyncThunk(
  "AssessmentAnswerGet/GET",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.AnswerGetUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const AssessmentVerifyGet = createAsyncThunk(
  "AssessmentVerifyGet/GET",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.AssessmentVerifyGet;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const AppraisalGet = createAsyncThunk(
  "AppraisalGet/GET",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.AppraisalGetController;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const RegGetData = createAsyncThunk(
  "RegGetData/getdata",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.regGetUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const FilterPostData = createAsyncThunk(
  "FilterPostData/postdata",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.filterPostUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const FilterGetData = createAsyncThunk(
  "FilterGetData/getdata",
  async ({ data }, thunkAPI) => {
    try {
      var url = store.getState().globalurl.filterGetUrl;
      console.log("get" + JSON.stringify(data));
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("🚀 ~ response.data:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const requestMail = createAsyncThunk(
  "email/rquestmail",
  async (data) => {
    var url = store.getState().globalurl.requestAcknowledgeUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const VoiceApi = async (input, compID, mgrID) => {
  try {
    const url = store.getState().globalurl.AIvoiceassistanturl;

    const response = await axios.post(url, {
      Input: input,
      CompID: compID,
      MgrID: mgrID,
    });

    return response.data;
  } catch (error) {
    console.error("AI Task API Error:", error);
    throw error;
  }
};
export const ApprovalVerify = createAsyncThunk(
  "email/ApprovalVerify",
  async (data) => {
    var url = store.getState().globalurl.ApprovalVerifyUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const PermissionApprovalVerify = createAsyncThunk(
  "email/PermissionApprovalVerify",
  async (data) => {
    var url = store.getState().globalurl.PermissionApprovalVerifyUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);


export const postWeightage = createAsyncThunk(
  "allScreen/Header",
  async ({ Type, data }, { rejectWithValue }) => {
    const url = store.getState().globalurl.weightagepostUrl;

    const payload = { Type, data };

    console.log("🚀 Request Payload:", JSON.stringify(payload));

    try {
      const response = await axios.post(url, payload, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });

      console.log("🚀 API Response:", response.data);
      return response.data;

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
);

export const sprintGetData = createAsyncThunk(
  "Project/Sprint",
  async ({ SprintHeaderID }) => {
    var url = store.getState().globalurl.SprintgetUrl;
    const data = {
      SprintHeaderID: SprintHeaderID,
    };

    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const sprintprojectplanGetData = createAsyncThunk(
  "Project Plan get/Sprint",
  async ({ ActivitiesID, FromDate, ToDate, BackLog }) => {
    var url = store.getState().globalurl.SprintPPGetUrl;
    const data = {
      ActivitiesID: ActivitiesID,
      FromDate: FromDate,
      ToDate: ToDate,
      BackLog: BackLog || "N",

    };

    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const paySlipGet = createAsyncThunk(
  "paySlipGet/Get",
  async (payslip) => {
    const url = store.getState().globalurl.PayslipGetController;

    const data = {
      EmployeeID: payslip.EmployeeID,
      CompanyID: payslip.CompanyID,
      Finyear: payslip.Finyear,
      Month: payslip.Month,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);

export const getFetchWeightage = createAsyncThunk(
  "allScreen/Header",
  async ({ Type, HeaderID, CompanyID }) => {
    const url = store.getState().globalurl.apiweightageUrl;

    const data = {
      Type: Type,  // Ensure lowercase if required by API
      HeaderID: HeaderID,
      CompanyID
    };

    console.log("🚀 Request Data:", JSON.stringify(data));

    try {
      const response = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });

      console.log("🚀 API Response:", response.data);
      return response.data;

    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Ensure proper error handling
    }
  }
);

export const mailNotify = createAsyncThunk(
  "email/mailNotify",
  async (data) => {
    var url = store.getState().globalurl.mailNotificationUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);


export const getLeaveentryData = createAsyncThunk(
  "Leave Entry/get",
  async ({ EmployeeID, LeaveTypeID, Year }) => {
    const url = store.getState().globalurl.getLeaveentryDataUrl;
    console.log(url, "--find url");

    const data = {
      EmployeeID: EmployeeID,
      LeaveTypeID: LeaveTypeID,
      Year: Year
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

//Spot Activity
// export const getSpotActivityData = createAsyncThunk(
//   "Manager Desk/Spot activity",
//   async ({ empID }) => {  
//     const url = store.getState().globalurl.spotActGetUrl;
// console.log(url, "--find url");

//     const data = {
//       empID: empID,
//          };
//     console.log("get" + JSON.stringify(data));
//     console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

//     const response = await axios.post(url, data, {
//       headers: {
//         Authorization:
//         "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
//       },
//     });
//     console.log(
//       "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
//       response
//     );
//     return response.data;
//   }
// );
export const getApprovallistData = createAsyncThunk(
  "Approvallist/get",
  async ({ LeaveID }) => {  // Destructure the CompanyID here
    const url = store.getState().globalurl.approvallisturl;
    console.log(url, "--find url");

    const data = {
      LeaveID  // Now using SubscriptionCode passed via the thunk
    };

    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const getSpotActivityData = createAsyncThunk(
  "Manager Desk/Spot activity",
  async ({ empID }) => {
    const url = store.getState().globalurl.spotActGetUrl;
    console.log(url, "--find url");

    var data = {
      Query: {
        empID: empID,
      },
    };
    console.log("get" + JSON.stringify(data))
    data = JSON.stringify(data);
    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.get(url, {
      params: {
        data: data,
      },
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    })
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const measureget = createAsyncThunk(
  "Expense/Measure Get",
  async ({ FinanceentryID, OverheadsRecordID }) => {
    const url = store.getState().globalurl.measuregeturl;
    console.log(url, "--find url");

    var data = {
      FinanceentryID: FinanceentryID,
      OverheadsRecordID: OverheadsRecordID
    };
    console.log("get" + JSON.stringify(data))
    data = JSON.stringify(data);
    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.get(url, {
      params: {
        data: data,
      },
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    })
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const measurepost = createAsyncThunk(
  "employee/Financemeasure/postdata",
  async (payload) => {
    const url = store.getState().globalurl.MeasureUpdate;

    console.log(" Final API Payload:", payload);

    const response = await axios.post(url, payload, {
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  }
);

export const costingBOMData = createAsyncThunk(
  "BOM/costing",
  async ({ HeaderRecordID, ProductRecordID }) => {
    var url = store.getState().globalurl.costingMatrialUrl;
    var data = {
      HeaderRecordID: HeaderRecordID,
      ProductRecordID: ProductRecordID,
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const materialDcTrckData = createAsyncThunk(
  "matrial/dc-tracking",
  async ({ MaterialID, Type }) => {
    var url = store.getState().globalurl.trackingUrl;
    var data = {
      MaterialID,
      Type,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const materialDcTrckChartData = createAsyncThunk(
  "matrial/dc-tracking-chart",
  async ({ RecordID, Type }) => {
    var url = store.getState().globalurl.materialsTrackingUrl;
    var data = {
      Query: {
        RecordID: RecordID,
        Type: Type
      },
    };
    data = JSON.stringify(data);
    console.log("get" + JSON.stringify(data));
    const response = await axios.get(url, {
      params: {
        data: data,
      },
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
//Material Stock Order
export const stockorder = createAsyncThunk(
  "material category/material stock order",
  async ({ data }) => {
    // var url = 'http://localhost:8080/MYPROJECT/lgems-api/materialStockOrderTrack.php'
    var url = store.getState().globalurl.stockorderUrl;

    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
// Material Procurement

export const procurementTrackingGet = createAsyncThunk(
  "materil/procurement",
  async ({ RecordID, Type }) => {
    var url = store.getState().globalurl.matProcurementUrl;
    var data = {
      Query: {
        RecordID: RecordID,
        Type
      },
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.get(url, {
      params: {
        data: JSON.stringify(data),
      },
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
//Customer Leather
export const customerLeather = createAsyncThunk(
  "customer/leather",
  async ({ HeaderRecordID, ProductRecordID, CustomerRecordID }) => {
    var url = store.getState().globalurl.customerLeatherUrl;
    var data = {
      HeaderRecordID: HeaderRecordID,
      ProductRecordID: ProductRecordID,
      CustomerRecordID: CustomerRecordID,
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

//DC Summary
export const dcSummary = createAsyncThunk(
  "delivery challan/summary",
  async ({ HeaderID }) => {
    var url = store.getState().globalurl.dcsummaryUrl;
    var data = {
      HeaderID: HeaderID,

    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const dcpostSummary = createAsyncThunk(
  "delivery challan/summary/postdata",
  async ({ data }) => {
    var url = store.getState().globalurl.dcpostsummaryUrl;
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
//Employee Deployment
export const getDeployment = createAsyncThunk(
  "employee/deployment",
  async ({ HeaderID }) => {
    var url = store.getState().globalurl.getempdeploymentUrl;
    var data = {
      HeaderID: HeaderID,

    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);//Employee_RESIGNATION_GET
export const getResignation = createAsyncThunk(
  "Personnel/Resignation",
  async ({ EmployeeID }) => {
    var url = store.getState().globalurl.getResignationUrl;
    var data = {
      EmployeeID: EmployeeID,
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);
//My_Profile
export const postDeployment = createAsyncThunk(
  "employee/deployment/postdata",
  async ({ data }) => {
    var url = store.getState().globalurl.postempdeployment;
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);


export const ResignationPOST = createAsyncThunk(
  "Personnel/Explore/postResignation",
  async ({ data }) => {
    var url = store.getState().globalurl.postResignation;
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response,
    );
    return response.data;
  },
);


//Employee Checkin
export const getCheckIn = createAsyncThunk(
  "employee/checkin",
  async ({ HeaderID }) => {
    var url = store.getState().globalurl.getempcheckinUrl;
    var data = {
      HeaderID: HeaderID,

    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const costLeatherData = createAsyncThunk(
  "bom/costing/leather",
  async ({ HeaderRecordID, LeatherRecordID, LeatherNumber }) => {
    var url = store.getState().globalurl.costingLeatherUrl;
    var data = {
      HeaderRecordID: HeaderRecordID,
      LeatherRecordID: LeatherRecordID,
      LeatherNumber
    };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  }
);

export const conversionMaterialData = createAsyncThunk(
  "Conversion",
  async ({ ConversionID }) => {
    var url = store.getState().globalurl.conversionUrl;
    var data = { ConversionID: ConversionID };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const uomMaterialRate = createAsyncThunk(
  "material/conversion",
  async ({ fromUomID, toUomID, Type }) => {
    var url = store.getState().globalurl.materialUomCovUrl;
    var data = { FromUOMID: fromUomID, ToUOMID: toUomID, Type };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const dpConversionData = createAsyncThunk(
  "Product/conversion",
  async ({ Purchase, FromID, Type, MaterialID }) => {
    //alert("purchase"+Purchase);
    var url = store.getState().globalurl.designPUrl;
    var data = { ConversionID: Purchase, FromID: FromID, Type: Type, MaterialID: MaterialID };
    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:98 ~ data:", data)
    //alert("data---"+data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const StockProcessApi = createAsyncThunk(
  "Stock/process",
  async (props) => {
    var url = store.getState().globalurl.imageNameUpdateUrl;
    var data = { accessid: props.accessID, Recordid: props.recID };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    // console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

export const bomCopyFn = createAsyncThunk(
  "Stock/process",
  async (BhprdRecordID) => {
    var url = store.getState().globalurl.bomCopyUrl;
    var data = { BhprdRecordID };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    // console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);
export const invoiceHeaderGetData = createAsyncThunk(
  "Invoice/Header",
  async (props) => {
    var url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: props.accessID,
      action: props.get,
      recid: props.recID,
    };

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);
export const RoutineHeaderGetData = createAsyncThunk(
  "Routine/Header",
  async (props) => {
    var url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: props.accessID,
      action: props.get,
      recid: props.recID,
    };

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

export const invoiceExploreGetData = createAsyncThunk(
  "Invoice/explore",
  async ({ accessID, get, recID }) => {
    var url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: accessID,
      action: get,
      recid: recID,
    };

    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

export const stockGetData = createAsyncThunk(
  "stock/material",
  async ({ accessID, Type, recID, yearData }) => {
    var url = store.getState().globalurl.stockUrl;
    var data = {
      Query: {
        accessid: accessID,
        recid: recID,
        Type: Type,
        Year: yearData,
      },
    };
    data = JSON.stringify(data);

    console.log("get" + data);
    const response = await axios
      .get(url, {
        params: {
          data: data,
        },

        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data.Data;
  }
);

export const InvoicePostData = createAsyncThunk(
  "PostData/header/details",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

export const Movements = createAsyncThunk(
  "Agile/Movements",
  async ({ data }) => {
    var url = store.getState().globalurl.movementsUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

//TreeData ProjectTeams 
export const ProjectTeamsTreeData = createAsyncThunk(
  "ProjectTeams/TreeData",
  async ({ ProjectID }) => {
    var url = store.getState().globalurl.treeUrl;
    const data = {
      ProjectID: ProjectID,

    };

    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const Invoicegenerate = createAsyncThunk(
  "invoice/attendance",
  async (data) => {
    const url = store.getState().globalurl.Invoicegenerate;

    console.log("POST DATA:", data);

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      }
    });

    return response.data;
  }
);
export const SprintInvoicegenerate = createAsyncThunk(
  "SprintInvoicegenerate/sprint",
  async (data) => {
    const url = store.getState().globalurl.SprintInvoicegenerate;

    console.log("POST DATA:", data);

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      }
    });

    return response.data;
  }
);
export const SprintInvoiceGet = createAsyncThunk(
  "SprintInvoiceGet/sprint",
  async (data) => {
    const url = store.getState().globalurl.SprintInvoiceGet;

    console.log("GET DATA:", data);

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      }
    });

    return response.data;
  }
);
export const Attendance = createAsyncThunk(
  "employee/attendance",
  async ({ data }) => {
    var url = store.getState().globalurl.attendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const MonthlyAttendance = createAsyncThunk(
  "employee/monthlyattendance",
  async ({ data }) => {
    var url = store.getState().globalurl.monthlyattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const AttendanceProcess = createAsyncThunk(
  "employee/attendanceprocess",
  async ({ data }) => {
    console.log("get" + JSON.stringify(data));
    var url = store.getState().globalurl.attendanceprocessUrl;


    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const InvoicePostExploreData = createAsyncThunk(
  "PostData/explore/details",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };
    console.log("🚀 ~ file: Formapireducer.js:209 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

export const getFetchData = createAsyncThunk(
  "allScreen/Header",
  async ({ accessID, get, recID, CustomerID, ProductID, BomID }) => {
    var url = store.getState().globalurl.apiUrl;
    var data = {};
    if (accessID === "TR091") {
      data = {
        accessid: accessID,
        action: get,
        CustomerID,
        ProductID,
        BomID,
      };
    } else {
      data = {
        accessid: accessID,
        action: get,
        recid: recID,
      };
    }

    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);



//Project Enquiryget
export const ProjectEnquiryGet = createAsyncThunk(
  "ProjectEnquiryGet/Agile",
  async ({ TaskDescription, CompanyID, ProjectID, MilestoneID, OperationStageID, ActivitesID, FromDate, ToDate, Status }) => {
    var url = store.getState().globalurl.ProjEnquiryUrl;
    const data = {
      TaskDescription: TaskDescription,
      CompanyID: CompanyID,
      ProjectID: ProjectID,
      MilestoneID: MilestoneID,
      OperationStageID: OperationStageID,
      ActivitesID: ActivitesID,
      FromDate: FromDate,
      ToDate: ToDate,
      Status: Status
    };

    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const SprintOccupancy = createAsyncThunk(
  "SprintOccupancy/Agile",
  async ({ EmployeeID, SprintDate }) => {
    var url = store.getState().globalurl.EmployeeSprintOccupancy;
    const data = { 
      EmployeeID: EmployeeID,   
      SprintDate: SprintDate
  
    };

    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

//AttendanceEntry Post
export const AttendanceEntryPost = createAsyncThunk(
  "PostData/Attendance Entry",
  async ({ AttendanceEntry }) => {
    const url = store.getState().globalurl.AttendanceentryrPostUrl;
    const data = {
      AttendanceEntry: AttendanceEntry,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);
export const RepaymentSchedule = createAsyncThunk(
  "Repayment/Schedule",
  async ({ SalaryAdvanceID, EmployeeID, Type, DueDate, FromPeriod, ToPeriod, DueAmount, Comments, Accountant }) => {
    const url = store.getState().globalurl.RepaymentScheduleGet;

    const data = {
      SalaryAdvanceID: SalaryAdvanceID,
      EmployeeID: EmployeeID,
      Type: Type,
      DueDate: DueDate,
      FromPeriod: FromPeriod,
      ToPeriod: ToPeriod,
      DueAmount: DueAmount,
      Comments: Comments,
      Accountant: Accountant
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    return response.data;
  },
);
// Daily TaskUpdate Comments get
export const scrumUpdateget = createAsyncThunk(
  "scrumUpdateget/ScrumUpdateGet",
  async ({ action, recID }) => {
    var url = store.getState().globalurl.scrumupdateGetUrl;
    const data = {
      action: action,
      recid: recID,
    };

    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const fetchProjectRoleData = createAsyncThunk(
  "projectRole/fetch",
  async ({ EmployeeProjectFilter }) => {
    const url = store.getState().globalurl.projectRoleurl;
    console.log(url, "--find url");

    const data = {
      EmployeeProjectFilter
    };

    console.log("🚀 ~ file: Formapireducer.js:225 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const postData = createAsyncThunk(
  "allScreen/post",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.apiUrl;

    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

//WFH_POST
export const wfhpostData = createAsyncThunk(
  "workfromHom/post",
  async ({ idata }) => {
    const url = store.getState().globalurl.HomeworkPOSTUrl;

    console.log("Sending Payload:", JSON.stringify(idata));

    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",

      },
    });

    return response.data;
  }
);

//HW_TeacherGet
export const HomeworkTeachGet = createAsyncThunk(
  "Mgr_Desk/homeworkTEACHER_get",
  async ({ accessid, action, recid, teacherID, appliedDate, targetDate }) => {
    const url = store.getState().globalurl.apiUrl;

    const data = {
      accessid: accessid,
      action: action,
      recid: recid,
      teacherID: teacherID,
      appliedDate: appliedDate,
      targetDate: targetDate
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

//HOMEWORK_EVAL_GET
export const HomeworkEvalGet = createAsyncThunk(
  "Mgr_Desk/homeworkeval_get",
  async ({ HomeWorkID, TeacherID }) => {
    const url = store.getState().globalurl.HomeworkEvalGetUrl;

    const data = {
      HomeWorkID: HomeWorkID,
      TeacherID: TeacherID,

    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

//HOMEWORK_EVAL_POST
export const HomeworkEvalPOST = createAsyncThunk(
  "HW_eval/post",
  async ({ idata }) => {
    const url = store.getState().globalurl.HomeworkEvalPOSTUrl;

    console.log("Sending Payload:", JSON.stringify(idata));

    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",

      },
    });

    return response.data;
  }
);

//HOMEWORK_ANALYTICS_GET

export const HomeworkEvalAnalyticsGet = createAsyncThunk(
  "Mgr_Desk/homeworke_Analyticschart_get",
  async (data) => {
    const url = store.getState().globalurl.HomeworkAnalticsGetUrl;

    const payload = {
      CompanyID: data.CompanyID,
      // HomeworkID: HomeworkID,
      StandardID: data.StandardID,
      SubjectID: data.SubjectID,
      GivenDate: data.GivenDate,
      TargetDate: data.TargetDate

    };
    console.log("get" + JSON.stringify(payload));
    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);
export const InvoiceAnalyticsget = createAsyncThunk(
  "Mgr_Desk/invoice_analytics_get",
  async (data, { rejectWithValue }) => {
    try {
      const url = store.getState().globalurl.InvoiceAnalytics;

      const payload = {
        CompanyID: data.CompanyID,
        CategoryID: data.CategoryID,
        staffID: data.staffID,
        fromPeriod: data.fromPeriod,
        toPeriod: data.toPeriod,
      };

      console.log("🔥 THUNK CALLED:", payload);
      console.log("🌐 URL:", url);

      const response = await axios.post(url, payload, {
        headers: {
          Authorization: "YOUR_TOKEN",
        },
      });

      console.log("✅ API RESPONSE:", response.data);

      return response.data;
    } catch (error) {
      console.error("❌ API ERROR:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const RepaymentSchedulePost = createAsyncThunk(
  "RepaymentSchedulePost/postdata",
  async ({ idata }) => {
    const url = store.getState().globalurl.RepaymentSchedulePost;

    console.log("Sending Payload:", JSON.stringify(idata));

    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",

      },
    });

    return response.data;
  }
);

//SCRUM TASK UPDATE POST

export const scrumUpdatepostData = createAsyncThunk(
  "scrumUpdate/postData",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.scrumupdateUrl;

    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

//Dashboard calendar post
export const DashcalpostData = createAsyncThunk(
  "Dashboard/calendar post",
  async ({ Year, Month, EmployeeID }) => {
    const url = store.getState().globalurl.dashcalUrl;
    //state.calenderEmpRecordID=EmployeeID;
    const data = {
      Year: Year,
      Month: Month,
      EmployeeID: EmployeeID,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);
//EVENT calendar GET
export const EventCalenderGet = createAsyncThunk(
  "EventCalenderGet/GET",
  async ({ Year, Month, CompanyID,EmployeeID }) => {
    const url = store.getState().globalurl.EventCalendarGet;
    //state.calenderEmpRecordID=EmployeeID;
    const data = {
      Year: Year,
      Month: Month,
      CompanyID: CompanyID,
      EmployeeID: EmployeeID,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);
//EVENT NOTIFICATIONS GET
export const EmergencyNotificationGet = createAsyncThunk(
  "EmergencyNotificationGet/GET",
  async ({ EventDate, CompanyID,EmployeeID }) => {
    const url = store.getState().globalurl.EmergencyNotificationGet;
    //state.calenderEmpRecordID=EmployeeID;
    const data = {
      EventDate: EventDate,
      CompanyID: CompanyID,
      EmployeeID: EmployeeID,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

export const CalendarpostData = createAsyncThunk(
  "CalpostScreen/post",
  async ({ CurDate, EmployeeID }) => {
    const url = store.getState().globalurl.CalUrl;

    const data = {
      CurDate,
      EmployeeID,
    };
    console.log("get" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);
export const timeSheetPostData = createAsyncThunk(
  "timeSheetPostData/post",
  async ({ idata }) => {
    var url = store.getState().globalurl.timesheetdtUrl;
    const response = await axios.post(url, idata, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const explorePostData = createAsyncThunk(
  "allScreen/post/explore",
  async ({ accessID, action, idata }) => {
    const url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: accessID,
      action: action,
      data: idata,
    };

    console.log("post" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

export const PackingListPostData = createAsyncThunk(
  "packinglist/post",
  async ({ accessID, action, idata, Type }) => {
    const url = store.getState().globalurl.apiUrl;
    const data = {
      accessid: accessID,
      action: action,
      data: idata,
      type: Type,
    };

    console.log("post" + JSON.stringify(data));
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    // console.log("🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:", response)
    return response.data;
  }
);

export const getVersionBom = createAsyncThunk(
  "product/bom",
  async ({ recID }) => {
    var url = store.getState().globalurl.commonUrl;
    var data = {
      recid: recID,
      action: "get",
      accessid: "",
    };


    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:314 ~ response:", response)
    return response.data;
  }
);
export const hashtoken = createAsyncThunk(
  "hashtoken/data",
  async ({ hashtoken }) => {
    var url = store.getState().globalurl.decryptUrl;
    console.log("Tokeeeeennn", hashtoken);


    const response = await axios.post(url, hashtoken, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    //alert("response",response);
    console.log("🚀 ~ file: Formapireducer.js:314 ~ response:", response)
    return response.data;
  }
);

export const getBomList = createAsyncThunk(
  "listOfBom/getbom",
  async ({ recid, action, ProductID }) => {
    const url = store.getState().globalurl.bomHeaderUrl;
    const data = {
      recid,
      action,
      ProductID,
    };


    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:314 ~ response:", response)
    return response.data;
  }
);
export const postPrdBthData = createAsyncThunk(
  "product/bom",
  async ({ data }) => {
    var url = store.getState().globalurl.prdCardBthUrl;
    console.log("🚀 ~ file: Formapireducer.js:334 ~ data:", JSON.stringify(data))
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:314 ~ response:", response)
    return response.data;
  }
);
export const getDCTracking = createAsyncThunk(
  "Deliverychalan/tracking",
  async ({ idata }) => {
    var url = store.getState().globalurl.dcTrackingUrl;
    var data = {
      ...idata
    };
    console.log("🚀 ~ file: Formapireducer.js:334 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:345 ~ response:", response)
    return response.data;
  }
);
export const proPriceTracking = createAsyncThunk(
  "Product/Price Tracking",
  async ({ idata }) => {
    var url = store.getState().globalurl.producttrackingUrl;
    var data = {
      ...idata
    };
    console.log("🚀 ~ file: Formapireducer.js:334 ~ data:", JSON.stringify(data))

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
      },
    });
    console.log("🚀 ~ file: Formapireducer.js:345 ~ response:", response)
    return response.data;
  }
);


// export function customerorderanalysis(RecordID,CompanyID,YearID) {
//   return async (dispatch) => {
//     function onSuccess(success) {
//        console.log("chartData---" +JSON.stringify(success));
//       // const datawait = dispatch(
//       //   stockReqSuccess({
//       //     stockReqapiResponse: success.data.Data,
//       //   })
//       // );
//       return success.data.Data;
//     }
//     function onError(error) {
//       //dispatch({ type: ERROR_GENERATED, error });
//       return error;
//     }
//     try {
//       var url = store.getState().globalurl.customerorderanalysisUrl;

//       var data = {
//         Query: {
//           RecordID: RecordID,
//           CompanyID:CompanyID,
//           Finyear:YearID
//         },
//       };
//       data = JSON.stringify(data);
//       // console.log("---"+url);
//       dispatch(pending());

//       const success = await axios.get(url, {
//         params: {
//           data: data,
//         },
//         headers: {
//           Authorization:
//             "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
//         },
//       });
//        console.log("chart Response---" + JSON.stringify(success));
//       return onSuccess(success);
//     } catch (error) {
//       return onError(error);
//     }
//   };
// }


export const customerorderanalysis = createAsyncThunk(
  "Customer Order/Analysis",
  async ({ data }) => {
    var url = store.getState().globalurl.customerorderanalysisUrl;

    console.log("🚀 ~ file: Formapireducer.js:334 ~ data:", JSON.stringify(data))

    const response = await axios.get(url, {
      params: {
        data: JSON.stringify(data),
      },
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",

      },
    });
    console.log("🚀 ~ file: Formapireducer.js:345 ~ response:", response)
    return response.data;
  }
);

export const productorderanalysis = createAsyncThunk(
  "Product Order/Analysis",
  async ({ data }) => {
    var url = store.getState().globalurl.prductorderanalysisUrl;

    console.log("🚀 ~ file: Formapireducer.js:334 ~ data:", JSON.stringify(data))

    const response = await axios.get(url, {
      params: {
        data: JSON.stringify(data),
      },
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",

      },
    });
    console.log("🚀 ~ file: Formapireducer.js:345 ~ response:", response)
    return response.data;
  }
);
export const getrole = createAsyncThunk(
  "Roleget/Analysis",
  async ({ data }) => {
    var url = store.getState().globalurl.projectRoleurl;

    console.log("🚀 ~ file: Formapireducer.js:334 ~ data:", JSON.stringify(data))

    const response = await axios.get(url, {
      params: {
        data: JSON.stringify(data),
      },
      headers: {
        Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",

      },
    });
    console.log("🚀 ~ file: Formapireducer.js:345 ~ response:", response)
    return response.data;
  }
);


export const getApiSlice = createSlice({
  name: "formApi",
  initialState,
  reducers: {
    setFilterGetData: (state, action) => {
      state.filterGetData = action.payload;
    },
    setRepaymentRows: (state, action) => {
      state.repaymentget = action.payload;
    },
    clearHWAnalyticsdata: (state) => {
      state.HWAnalyticsdata = {};
      state.HWAnalyticsloading = false;
      state.HWAnalyticsstatus = "idle";
    },
    resetTrackingData(state) {
      state.PSRData = []
      state.PSRempTaskData = []
      state.PSRprojectTaskData = []
      state.trackingData = []
      state.ProjEnqGET = []
      state.customerData = {}
      state.productanalysisData = {}
      state.summeryData = []
      state.stockorderData = []
      state.MovementsData = []
      state.AttendanceData = []
      state.empinvoicedata = []
      state.MonthlyAttendanceData = []
      state.empAttendanceData = []
      // state.repaymentget = []
      state.repaymentget = []
      state.InvoiceHeaderData = []
      state.InvoiceDetailData = []
      state.timeSheetData = [];
      state.PSRprojectTaskData = [];
      state.costingLeatherCost.leatherOneCost = 0
      state.costingLeatherCost.leatherTwoCost = 0
      state.costingLeatherCost.leatherThreeCost = 0
      state.costingLeatherCost.materialCost = 0
      state.TeachergetData = [];
      state.TeachinvoicegetData = []
    },
    packingListCarton(state, action) {
      console.log("🚀 ~ file: Formapireducer.js:502 ~ packingListCarton ~ action:", action)
      console.log("action called");
      switch (action.payload.type) {

        case "INSERTED":
          state.pakingListCarton.push(...action.payload.data)
          break
        case "EDITED":
          state.pakingListCarton = action.payload.data
          break
        case "RESET":
          state.pakingListCarton = []
          break
      }
    },
    pending(state) {
      return {
        ...state,
        loading: true,
        error: false,
        Data: {},
      };
    },
    errored(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    Success(state, action) {
      if (action.payload.action == "get") {
        return {
          ...state,
          loading: false,
          error: "",
          Data: action.payload.apiResponse,
        };
      } else {
        return {
          ...state,
          loading: false,
          error: "",
          Data: action.payload.apiResponse,
          Status: action.payload.Status,
          msg: action.payload.Msg,
          Successflag: true,
        };
      }
    },
    stockSuccess(state, action) {
      return {
        ...state,
        stockValue: action.payload.stockapiResponse,
      };
    },
    stockReqSuccess(state, action) {
      return {
        ...state,

        stockReqData: action.payload.stockReqapiResponse,
      };
    },
    userGroupUpdate(state, action) {
      state.userGroup = action.payload.rowData;
    },

    //FOR PROJECT REPORT - PIE CHART 
    resetProjectStatusReport: (state) => {
      state.ProjectStatusReportData = {};
      state.ProjectStatusReportLoading = false;
    },

    //FOR PROJECT REPORT - BAR CHART 
    resetPSRBarChart: (state) => {
      state.PSRBarChartData = {};
      state.PSRBarChartLoading = false;
    },

    //FOR ProductCosting - BAR CHART 
    resetProductCostingBar: (state) => {
      state.ProductCostingData = {};
      state.ProductCostingLoading = false;
    },
    //FOR Costing OVERVIEW - BAR CHART 
    resetCostOverviewBar: (state) => {
      state.CostOverviewData = {};
      state.CostOverviewLoading = false;
    },
    //FOR COST TREND - LINE CHART 
    resetCostTrendBar: (state) => {
      state.CostTrendData = {};
      state.CostTrendLoading = false;
    },
    //FOR COST TREND - LINE CHART 
    resetEmployeeOverrunBar: (state) => {
      state.EmployeeOverrunData = {};
      state.EmployeeOverrunLoading = false;
    },
    //FOR Project Manager Dashboard
    resetProjectManagerDashboard: (state) => {
      state.ProjectManagerDashboardData = {};
      state.ProjectManagerDashboardLoading = false;
    },
    //FOR Project Manager Dashboard
    resetTimeSheetAttendance: (state) => {
      state.timeSheetData = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(invoiceHeaderGetData.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(invoiceHeaderGetData.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        if (action.payload.Data.Disable == "Y") {
          action.payload.Data.Disable = true;
        } else action.payload.Data.Disable = false;

        state.Data = action.payload.Data;
      })
      .addCase(invoiceHeaderGetData.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })
      .addCase(invoiceExploreGetData.pending, (state, action) => {
        state.Status = "idle";
        // state.loading = true
      })
      .addCase(invoiceExploreGetData.fulfilled, (state, action) => {
        state.Status = "success";
        //  state.loading = false
        if (action.payload.Data.Disable == "Y") {
          action.payload.Data.Disable = true;
        } else action.payload.Data.Disable = false;

        state.inviceEData = action.payload.Data;
      })
      .addCase(invoiceExploreGetData.rejected, (state, action) => {
        state.Status = "Error";
        //  state.loading = false
      })

      .addCase(InvoicePostData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(InvoicePostData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
        if (action.meta.arg.idata.Disable == "Y") {
          action.meta.arg.idata.Disable = true;
        } else action.meta.arg.idata.Disable = false;
        if (action.meta.arg.accessID !== "TR012") {
          state.data = action.meta.arg.idata;
        }
      })
      .addCase(InvoicePostData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })
      .addCase(InvoicePostExploreData.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(InvoicePostExploreData.fulfilled, (state, action) => {
        if (action.meta.arg.idata.Disable == "Y") {
          action.meta.arg.idata.Disable = true;
        } else action.meta.arg.idata.Disable = false;
        state.inviceEData = action.meta.arg.idata;
      })
      .addCase(InvoicePostExploreData.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })
      //SpotGetDta

      .addCase(getSpotActivityData.pending, (state, action) => {
        state.Status = "idle";
        state.getLoading = true;
        state.SpotGetData = [];
        state.msg = "Loading..."
      })
      .addCase(getSpotActivityData.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.SpotGetData = action.payload.Data ? action.payload.Data : [];
        state.msg = action.payload.Msg
      })
      .addCase(getSpotActivityData.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        state.SpotGetData = [];
        state.msg = action.payload.Msg
      })
      .addCase(measureget.pending, (state, action) => {
        state.Status = "idle";
        state.getLoading = true;
        state.MeasureGetData = [];
        state.msg = "Loading..."
      })
      .addCase(measureget.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.MeasureGetData = action.payload.Data ? action.payload.Data : [];
        //  state.Partygetdata = action.payload.Data
        //   ? action.payload.Data
        //   : [];
        state.msg = action.payload.Msg
      })
      .addCase(measureget.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        state.MeasureGetData = [];
        state.msg = action.payload.Msg
      })


      .addCase(getFetchData.pending, (state, action) => {
        state.Status = "idle";
        state.getLoading = true;
        state.Data = {};
        state.msg = "Loading..."
      })
      .addCase(getFetchData.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.Data = action.payload.Data ? action.payload.Data : {};
        state.msg = action.payload.Msg
      })
      .addCase(getFetchData.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        state.Data = {};
        state.msg = action.payload.Msg
      })
      //dashcal Post Data


      //Skillglow
      .addCase(AssessmentAnswerGet.pending, (state, action) => {
        state.SkilGlowAnswerGetStatus = "pending";
        state.SkilGlowAnswerGetLoading = true;
        state.SkilGlowAnswerGetData = [];
      })
      .addCase(AssessmentAnswerGet.fulfilled, (state, action) => {
        state.SkilGlowAnswerGetStatus = "fulfilled";
        state.SkilGlowAnswerGetLoading = false;
        state.SkilGlowAnswerGetData = action.payload.Data ? action.payload.Data : [];
      })
      .addCase(AssessmentAnswerGet.rejected, (state, action) => {
        state.SkilGlowAnswerGetStatus = "rejected";
        state.SkilGlowAnswerGetLoading = false;
        state.SkilGlowAnswerGetData = [];
      })
      //Skillglow
      .addCase(AssessmentVerifyGet.pending, (state, action) => {
        state.AssessmentVerifyGetStatus = "pending";
        state.AssessmentVerifyGetLoading = true;
        state.AssessmentVerifyGetData = [];
      })
      .addCase(AssessmentVerifyGet.fulfilled, (state, action) => {
        state.AssessmentVerifyGetStatus = "fulfilled";
        state.AssessmentVerifyGetLoading = false;
        state.AssessmentVerifyGetData = action.payload.Data ? action.payload.Data : [];
      })
      .addCase(AssessmentVerifyGet.rejected, (state, action) => {
        state.AssessmentVerifyGetStatus = "rejected";
        state.AssessmentVerifyGetLoading = false;
        state.AssessmentVerifyGetData = [];
      })
      //Skillglow
      .addCase(AssessmentVerifyUpdateController.pending, (state, action) => {
        state.AssessmentVerifyPostStatus = "pending";
        state.AssessmentVerifyPostLoading = true;
        state.AssessmentVerifyPostData = [];
      })
      .addCase(AssessmentVerifyUpdateController.fulfilled, (state, action) => {
        state.AssessmentVerifyPostStatus = "fulfilled";
        state.AssessmentVerifyPostLoading = false;
        state.AssessmentVerifyPostData = action.payload.Data ? action.payload.Data : [];
      })
      .addCase(AssessmentVerifyUpdateController.rejected, (state, action) => {
        state.AssessmentVerifyPostStatus = "rejected";
        state.AssessmentVerifyPostLoading = false;
        state.AssessmentVerifyPostData = [];
      })
      //Skillglow
      .addCase(EmergencyNotificationPost.pending, (state, action) => {
        state.EmergencyNotificationPostStatus = "pending";
        state.EmergencyNotificationPostLoading = true;
        state.EmergencyNotificationPostData = [];
      })
      .addCase(EmergencyNotificationPost.fulfilled, (state, action) => {
        state.EmergencyNotificationPostStatus = "fulfilled";
        state.EmergencyNotificationPostLoading = false;
        state.EmergencyNotificationPostData = action.payload;
      })
      .addCase(EmergencyNotificationPost.rejected, (state, action) => {
        state.EmergencyNotificationPostStatus = "rejected";
        state.EmergencyNotificationPostLoading = false;
        state.EmergencyNotificationPostData = [];
      })
      //Skillglow - EVALUATION
      .addCase(AssessmentEvaluateController.pending, (state, action) => {
        state.AssessmentEvaluateStatus = "pending";
        state.AssessmentEvaluateLoading = true;
        state.AssessmentEvaluateData = [];
      })
      .addCase(AssessmentEvaluateController.fulfilled, (state, action) => {
        state.AssessmentEvaluateStatus = "fulfilled";
        state.AssessmentEvaluateLoading = false;
        // state.AssessmentEvaluateData = action.payload.Data ? action.payload.Data : [];
        state.AssessmentEvaluateData = action.payload ? action.payload : [];
      })
      .addCase(AssessmentEvaluateController.rejected, (state, action) => {
        state.AssessmentEvaluateStatus = "rejected";
        state.AssessmentEvaluateLoading = false;
        state.AssessmentEvaluateData = [];
      })
      //Skillglow - EVALUATION
      .addCase(DashboardVisualLeaveApproval.pending, (state, action) => {
        state.DVLeaveApprovalStatus = "pending";
        state.DVLeaveApprovalLoading = true;
        state.DVLeaveApprovalData = [];
      })
      .addCase(DashboardVisualLeaveApproval.fulfilled, (state, action) => {
        state.DVLeaveApprovalStatus = "fulfilled";
        state.DVLeaveApprovalLoading = false;
        // state.DVLeaveApprovalData = action.payload.Data ? action.payload.Data : [];
        state.DVLeaveApprovalData = action.payload ? action.payload : [];
      })
      .addCase(DashboardVisualLeaveApproval.rejected, (state, action) => {
        state.DVLeaveApprovalStatus = "rejected";
        state.DVLeaveApprovalLoading = false;
        state.DVLeaveApprovalData = [];
      })


      //Apprsail
      .addCase(AppraisalGet.pending, (state, action) => {
        state.SkilGlowAppraisalGetStatus = "pending";
        state.SkilGlowAppraisalGetLoading = true;
        state.SkilGlowAppraisalGetData = [];
      })
      .addCase(AppraisalGet.fulfilled, (state, action) => {
        state.SkilGlowAppraisalGetStatus = "fulfilled";
        state.SkilGlowAppraisalGetLoading = false;
        state.SkilGlowAppraisalGetData = action.payload.Data ? action.payload.Data : [];
      })
      .addCase(AppraisalGet.rejected, (state, action) => {
        state.SkilGlowAppraisalGetStatus = "rejected";
        state.SkilGlowAppraisalGetLoading = false;
        state.SkilGlowAppraisalGetData = [];
      })

      //ATTENEntry Post
      .addCase(AttendanceEntryPost.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(AttendanceEntryPost.fulfilled, (state, action) => {
        console.log("🚀 ~ .addCase ~ action:", action)
        state.Status = "success";
        state.postLoading = false;

        // if (action.meta.arg.idata.Disable == "Y") {
        //   action.meta.arg.idata.Disable = true;
        // } else action.meta.arg.idata.Disable = false;

        state.Data = action.meta.arg.idata;
      })
      .addCase(AttendanceEntryPost.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })

      // Project Enquiry GET
      .addCase(ProjectEnquiryGet.pending, (state, action) => {
        state.Status = "idle";
        state.getLoading = true;
        state.ProjEnqGET = [];
        state.msg = "Loading..."
      })
      .addCase(ProjectEnquiryGet.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.ProjEnqGET = action.payload.Data ? action.payload.Data : [];
        state.msg = action.payload.Msg
      })
      .addCase(ProjectEnquiryGet.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        state.ProjEnqGET = [];
        state.msg = action.payload.Msg
      })
      //Scrum Task Get

      .addCase(scrumUpdateget.pending, (state, action) => {
        // state.Status = "idle";
        // state.getLoading = true;
        state.scrumget = [];
        state.msg = "Loading..."
      })
      .addCase(scrumUpdateget.fulfilled, (state, action) => {
        // state.Status = "success";
        // state.getLoading = false;
        state.scrumget = action.payload.Data ? action.payload.Data : [];
        state.msg = action.payload.Msg
      })
      .addCase(scrumUpdateget.rejected, (state, action) => {
        // state.Status = "Error";
        // state.getLoading = false;
        state.scrumget = [];
        state.msg = action.payload.Msg
      })
      //RepaymentSchedule
      .addCase(RepaymentSchedule.pending, (state) => {
        state.repaymentgetLoading = true;
        state.repaymentget = [];
      })

      .addCase(RepaymentSchedule.fulfilled, (state, action) => {
        state.repaymentgetLoading = false;
        state.repaymentget = action.payload.data ? action.payload.data : [];
        state.msg = action.payload.Msg;
      })

      .addCase(RepaymentSchedule.rejected, (state, action) => {
        state.repaymentgetLoading = false;
        state.repaymentget = [];
        state.msg = action.error?.message || "";
      })
      .addCase(DashcalpostData.pending, (state, action) => {
        state.calStatus = "idle";
        state.calendarloading = true;
      })
      .addCase(DashcalpostData.fulfilled, (state, action) => {
        console.log("🚀 ~ .addCase ~ action:", action)
        state.calStatus = "success";
        state.calendarloading = false;
        state.calenderEmpRecordID = action.meta.arg.EmployeeID;
        // if (action.meta.arg.idata.Disable == "Y") {
        //   action.meta.arg.idata.Disable = true;
        // } else action.meta.arg.idata.Disable = false;

        state.calendardata = action.payload.Data;
      })
      .addCase(DashcalpostData.rejected, (state, action) => {
        state.calStatus = "Error";
        state.calendarloading = false;
      })
      .addCase(EventCalenderGet.pending, (state, action) => {
        state.EventStatus = "idle";
        state.EventCalendarloading = true;
      })
      .addCase(EventCalenderGet.fulfilled, (state, action) => {
        console.log("🚀 ~ .addCase ~ action:", action)
        state.EventStatus = "success";
        state.EventCalendarloading = false;
        state.EventCalendarEmpRecordID = action.meta.arg.EmployeeID;
        // if (action.meta.arg.idata.Disable == "Y") {
        //   action.meta.arg.idata.Disable = true;
        // } else action.meta.arg.idata.Disable = false;

        state.EventCalendarData = action.payload.Data;
      })
      .addCase(EventCalenderGet.rejected, (state, action) => {
        state.EventStatus = "Error";
        state.EventCalendarloading = false;
      })
      .addCase(EmergencyNotificationGet.pending, (state, action) => {
        state.EventNotificationStatus = "idle";
        state.EventNotificationloading = true;
      })
      .addCase(EmergencyNotificationGet.fulfilled, (state, action) => {
        state.EventNotificationStatus = "success";
        state.EventNotificationloading = false;
        state.EventNotificationData = action.payload;
      })
      .addCase(EmergencyNotificationGet.rejected, (state, action) => {
        state.EventNotificationStatus = "Error";
        state.EventNotificationloading = false;
      })

      .addCase(scrumUpdatepostData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(scrumUpdatepostData.fulfilled, (state, action) => {
        console.log("🚀 ~ .addCase ~ action:", action)
        state.Status = "success";
        state.postLoading = false;

        // if (action.meta.arg.idata.Disable == "Y") {
        //   action.meta.arg.idata.Disable = true;
        // } else action.meta.arg.idata.Disable = false;

        state.Data = action.meta.arg.idata;
      })
      .addCase(scrumUpdatepostData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })



      .addCase(postData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(postData.fulfilled, (state, action) => {
        console.log("🚀 ~ .addCase ~ action:", action)
        state.Status = "success";
        state.postLoading = false;

        // if (action.meta.arg.idata.Disable == "Y") {
        //   action.meta.arg.idata.Disable = true;
        // } else action.meta.arg.idata.Disable = false;

        state.Data = action.meta.arg.idata;
      })
      .addCase(postData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })

      .addCase(explorePostData.pending, (state, action) => {
        state.Status = "idle";
        state.postLoading = true;
      })
      .addCase(explorePostData.fulfilled, (state, action) => {
        state.Status = "success";
        state.postLoading = false;
      })
      .addCase(explorePostData.rejected, (state, action) => {
        state.Status = "Error";
        state.postLoading = false;
      })
      .addCase(dpConversionData.fulfilled, (state, action) => {
        state.conversionData = action.payload;
        // console.log("🚀 ~ file: Formapireducer.js:373 ~ .addCase ~ action:", action)
      })
      .addCase(stockGetData.fulfilled, (state, action) => {
        state.materialStockData = action.payload;
        // console.log("🚀 ~ file: Formapireducer.js:373 ~ .addCase ~ action:", action)
      })
      .addCase(getVersionBom.fulfilled, (state, action) => {
        state.Status = "success";

        state.exploreData = action.payload.Data ? action.payload.Data : "N";
      })
      .addCase(hashtoken.fulfilled, (state, action) => {
        state.Status = "success";

        state.hashtokenData = action.payload;
      })
      .addCase(getBomList.fulfilled, (state, action) => {
        state.Status = "success";

        state.exploreData = action.payload.Data;
      })
      .addCase(getDCTracking.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(getDCTracking.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.trackingData = action.payload.Data;
        state.summeryData = action.payload.Summary;
      })
      .addCase(getDCTracking.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })
      .addCase(proPriceTracking.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(proPriceTracking.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.trackingData = action.payload.Data;
      })
      .addCase(proPriceTracking.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })
      .addCase(customerorderanalysis.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.customerData = action.payload.Data;
      })
      .addCase(productorderanalysis.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.productanalysisData = action.payload.Data;
      })
      .addCase(uomMaterialRate.fulfilled, (state, action) => {
        state.conversionData = action.payload
      })
      .addCase(Movements.pending, (state, action) => {
        state.Status = "idle";
        state.loading = true;
      })
      .addCase(Movements.fulfilled, (state, action) => {
        state.Status = "success";
        state.loading = false;
        state.MovementsData = action.payload.Data;

      })
      .addCase(Movements.rejected, (state, action) => {
        state.Status = "Error";
        state.loading = false;
      })
      .addCase(Attendance.fulfilled, (state, action) => {
        state.Status = "success";
        state.AttendanceData = action.payload.Data;
        state.AttendanceMonthlyloading = false;
      })
      .addCase(Attendance.pending, (state, action) => {
        state.Status = "idle";
        state.AttendanceData = [];
        state.AttendanceMonthlyloading = true;
      })
      .addCase(Attendance.rejected, (state, action) => {
        state.Status = "Error";
        state.AttendanceData = [];
        state.AttendanceMonthlyloading = false;
      })
      .addCase(empinvoicecheck.fulfilled, (state, action) => {
        state.Status = "success";
        state.empinvoicedata = action.payload.Data;
        state.empinvoiceMonthlyloading = false;

      })
      .addCase(empinvoicecheck.pending, (state, action) => {
        state.Status = "idle";
        state.empinvoicedata = [];
        state.empinvoiceMonthlyloading = true;
      })
       .addCase(empinvoicecheck.rejected, (state, action) => {
        state.Status = "Error";
        state.empinvoicedata = [];
        state.empinvoiceMonthlyloading = false;
      })
      //treeData
      .addCase(ProjectTeamsTreeData.pending, (state, action) => {
        state.TreeDatalStatus = "idle";
        state.TreeDataloading = true;
      })
      .addCase(ProjectTeamsTreeData.fulfilled, (state, action) => {
        state.TreeDatalStatus = "success";
        state.TreeDataloading = false;
        state.TreeData = action.payload.Data;
      })
      .addCase(ProjectTeamsTreeData.rejected, (state, action) => {
        state.TreeDatalStatus = "Error";
        state.TreeDataloading = false;
      })

      .addCase(MonthlyAttendance.fulfilled, (state, action) => {

        state.MonthlyAttendanceData = action.payload.Data;
        state.AttendanceDailyloading = false;
      })
       .addCase(MonthlyAttendance.pending, (state, action) => {
        state.Status = "idle";
        state.AttendanceDailyloading = true;
      })
      .addCase(costLeatherData.fulfilled, (state, action) => {
        console.log("🚀 ~ file: Formapireducer.js:863 ~ .addCase ~ action:", action)

        if (action.meta.arg.LeatherNumber == 1) {
          state.costingLeatherCost.leatherOneCost = Number(action.payload.LeatherCost).toFixed(2)
        }
        if (action.meta.arg.LeatherNumber == 2) {
          state.costingLeatherCost.leatherTwoCost = Number(action.payload.LeatherCost).toFixed(2)
        }
        if (action.meta.arg.LeatherNumber == 3) {
          state.costingLeatherCost.leatherThreeCost = Number(action.payload.LeatherCost).toFixed(2)
        }
      })
      .addCase(costingBOMData.fulfilled, (state, action) => {
        state.costingLeatherCost.materialCost = Number(action.payload.Cost).toFixed(2)
      })
      .addCase(RoutineHeaderGetData.pending, (state, action) => {
        state.routinegetstatus = "idle";
        state.routineloading = true;
        state.routineget = {}
        // state.msg =  "Loading..."
      })
      .addCase(RoutineHeaderGetData.fulfilled, (state, action) => {
        state.routinegetstatus = "success";
        state.routineloading = false;
        state.routineget = action.payload.Data ? action.payload.Data.headerData : {};
        state.routinePPget = action.payload.Data.configsData;
        // state.msg =  action.payload.Msg

      })

      .addCase(RoutineHeaderGetData.rejected, (state, action) => {
        state.routinegetstatus = "Error";
        state.routineloading = false;
        state.routineget = {}
        state.routinePPget = {}
        //  toast.error('Something Went Wrong')
      })

      .addCase(sprintGetData.pending, (state, action) => {
        state.sprintgetstatus = "idle";
        state.sprintloading = true;
        state.sprintget = {};
        // state.msg =  "Loading..."
      })
      .addCase(sprintGetData.fulfilled, (state, action) => {
        state.sprintgetstatus = "success";
        state.sprintloading = false;
        state.sprintget = action.payload.Data ? action.payload.Data.headerData : {};
        state.sprintPPget = action.payload.Data.detailData;
        // state.msg =  action.payload.Msg

      })

      .addCase(sprintGetData.rejected, (state, action) => {
        state.sprintgetstatus = "Error";
        state.sprintloading = false;
        state.sprintget = [];
        //  toast.error('Something Went Wrong')
      })
      //Sprint PP GET 
      .addCase(sprintprojectplanGetData.pending, (state, action) => {
        // state.sprintgetstatus = "idle";
        state.sprintloading = true;
        state.sprintPPget = [];
        // state.msg =  "Loading..."
      })
      .addCase(sprintprojectplanGetData.fulfilled, (state, action) => {
        // state.sprintgetstatus = "success";
        state.sprintloading = false;
        state.sprintPPget = action.payload.Data ? action.payload.Data : [];
        // state.msg =  action.payload.Msg
        console.log(state.sprintPPget, "--sprintprojectplanGetData state.sprintPPget");

      })
      .addCase(sprintprojectplanGetData.rejected, (state, action) => {
        // state.sprintgetstatus = "Error";
        state.sprintloading = false;
        state.sprintPPget = [];
        //  toast.error('Something Went Wrong')
      })

      //Leave Entry
      .addCase(getLeaveentryData.fulfilled, (state, action) => {
        state.LeaveEntryData = action.payload.Data
        state.getLoading = false;
      })

      .addCase(getCheckIn.fulfilled, (state, action) => {
        state.checkInOutData = action.payload.data
        state.getLoading = false;
      })
      .addCase(customerLeather.fulfilled, (state, action) => {
        state.customerLeatherData = action.payload;

      })
      .addCase(dcSummary.fulfilled, (state, action) => {
        state.summaryData = action.payload.Data;
      })
      .addCase(getDeployment.fulfilled, (state, action) => {
        state.deploymentData = action.payload.Data;
      })
      .addCase(getResignation.fulfilled, (state, action) => {
        state.ResignationGetData = action.payload.Data;
      })
      .addCase(getApprovallistData.pending, (state, action) => {
        state.Status = "loading";
        state.getLoading = true;
        state.approvalList = [];
        state.Header = {};     // ✅ Clear the header too, so stale data is gone
        state.msg = "Loading...";
      })

      .addCase(getApprovallistData.fulfilled, (state, action) => {
        state.Status = "success";
        state.getLoading = false;
        state.Header = action.payload.Header || {}; // ✅ fallback if API misbehaves
        state.approvalList = action.payload.Data || [];
      })

      .addCase(getApprovallistData.rejected, (state, action) => {
        state.Status = "Error";
        state.getLoading = false;
        state.approvalList = [];
        state.Header = {};     // ✅ clear header on error too
      })


      .addCase(procurementTrackingGet.pending, (state, action) => {
        state.Status = "idle";
        state.trackingLoading = true;
        state.materialTrackingData = {
          Rateseries: {},
          Qtyseries: {},
          Amountseries: {},
          categories: [],
          TableData: { data: [] },
        }
      })
      .addCase(procurementTrackingGet.fulfilled, (state, action) => {
        state.Status = "success";
        state.trackingLoading = false;
        state.materialTrackingData = action.payload.Data;
      })
      .addCase(procurementTrackingGet.rejected, (state, action) => {
        state.Status = "Error";
        state.trackingLoading = false;
        state.materialTrackingData = {};
      })
      .addCase(materialDcTrckData.pending, (state, action) => {
        state.Status = "idle";
        state.trackingLoading = true;
        state.matrialDcTrackData = []
      })
      .addCase(materialDcTrckData.fulfilled, (state, action) => {
        state.Status = "success";
        state.trackingLoading = false;
        state.matrialDcTrackData = action.payload.Data;
      })
      .addCase(materialDcTrckData.rejected, (state, action) => {
        state.Status = "Error";
        state.trackingLoading = false;
        state.matrialDcTrackData = []
      })
      .addCase(materialDcTrckChartData.fulfilled, (state, action) => {
        // state.Status = "success";
        // state.trackingLoading = false;
        state.stockReqData = action.payload.Data;
      })
      .addCase(stockorder.pending, (state, action) => {
        state.Status = "idle";
        state.trackingLoading = true;
        state.stockorderData = []
      })
      .addCase(stockorder.fulfilled, (state, action) => {
        state.trackingLoading = false;
        state.stockorderData = action.payload.data;
      })
      .addCase(stockorder.rejected, (state, action) => {
        state.Status = "Error";
        state.trackingLoading = false;
        state.stockorderData = []
      })
      .addCase(empAttendance.fulfilled, (state, action) => {

        state.empAttendanceData = action.payload.Data ? action.payload.Data : [];
        state.empAttendanceDataLoading = false;
      })
      .addCase(empAttendance.pending, (state, action) => {
        state.Status = "idle";
        state.empAttendanceDataLoading = true;
        state.empAttendanceData = []
      })
      .addCase(empAttendance.rejected, (state, action) => {
        state.Status = "Error";
        state.empAttendanceDataLoading = false;
        state.empAttendanceData = []
      })
      .addCase(RepaymentHDget.pending, (state) => {
        state.Status = "loading";
        state.RepaymentHDgetDataLoading = true;

        state.RepaymentHDgetHeader = {};
        state.RepaymentHDgetData = [];
      })

      .addCase(RepaymentHDget.fulfilled, (state, action) => {
        state.Status = "success";
        state.RepaymentHDgetDataLoading = false;

        state.RepaymentHDgetHeader = action.payload.Header
          ? action.payload.Header
          : {};

        state.RepaymentHDgetData = action.payload.Data
          ? action.payload.Data
          : [];
      })

      .addCase(RepaymentHDget.rejected, (state) => {
        state.Status = "error";
        state.RepaymentHDgetDataLoading = false;

        state.RepaymentHDgetHeader = {};
        state.RepaymentHDgetData = [];
      })
      // .addCase(Invoicegenerate.fulfilled, (state, action) => {

      //   state.InvoicegenerateData = action.payload.Data ? action.payload.Data : [];

      // })
      .addCase(Invoicegenerate.fulfilled, (state, action) => {
        state.InvoiceHeaderData =
          action.payload.HeaderData ? action.payload.HeaderData : [];

        state.InvoiceDetailData =
          action.payload.DetailData ? action.payload.DetailData : [];

      })
      .addCase(SprintInvoicegenerate.fulfilled, (state, action) => {
        state.Status = action.payload.Status;
        state.Code = action.payload.Code;
        state.Msg = action.payload.Msg;

      })
      .addCase(SprintInvoiceGet.fulfilled, (state, action) => {
        state.HeaderData =
          action.payload.HeaderData ? action.payload.HeaderData : [];

        state.DetailData =
          action.payload.DetailData ? action.payload.DetailData : [];

      })

//Teacher_GET
.addCase(Teacherget.pending, (state, action) => {

        state.TeachergetData = [];
        state.TeachergetLoading = true;
    
      })
      .addCase(Teacherget.fulfilled, (state, action) => {

        state.TeachergetData = action.payload?.Data || [];
        state.TeachergetLoading = false;
       
      })
      .addCase(Teacherget.rejected, (state, action) => {

        state.TeachergetData = [];
        state.TeachergetLoading = false;
       
      })
      //Teacher_Invoice_Get
      .addCase(TeacherInvoiceget.pending, (state, action) => {

        state.TeachinvoicegetData = [];
        state.TeachinvoiceLoading = true;
    
      })
      .addCase(TeacherInvoiceget.fulfilled, (state, action) => {

        state.TeachinvoicegetData = action.payload?.Data || [];
        state.TeachinvoiceLoading = false;
       
      })
      .addCase(TeacherInvoiceget.rejected, (state, action) => {

        state.TeachinvoicegetData = [];
        state.TeachinvoiceLoading = false;
       
      })
      


      .addCase(timeSheet.pending, (state, action) => {

        state.timeSheetData = [];
        state.timeSheetLoading = true;
        state.projectName = "";
        state.managerName = "";
      })
      .addCase(timeSheet.fulfilled, (state, action) => {

        state.timeSheetData = action.payload?.Data?.Task || [];
        state.timeSheetLoading = false;
        state.projectName = action.payload?.Data?.ProjectName?.ProjectName || "";
        state.managerName = action.payload?.Data?.ManagersName?.ManagersName || "";
      })
      .addCase(timeSheet.rejected, (state, action) => {

        state.timeSheetData = [];
        state.timeSheetLoading = false;
        state.projectName = "";
        state.managerName = "";
      })

      //PSR Report addCase
      .addCase(PSRreportpost.pending, (state, action) => {
        state.PSRStatus = "idle";
        state.PSRLoading = true;
        state.PSRData = [];
        state.PSRempTaskData = [];
        state.PSRprojectTaskData = [];
      })
      .addCase(PSRreportpost.fulfilled, (state, action) => {
        state.trackingLoading = false;
        state.PSRLoading = false;
        state.PSRData = action.payload?.Data?.Task || [];
        state.PSRempTaskData = action.payload?.Data?.EmployeeTask || [];
        state.PSRprojectTaskData = action.payload?.Data?.ListofProject || [];
        state.projectName = action.payload?.Data?.ProjectName?.ProjectName || "";
        state.managerName = action.payload?.Data?.ManagersName?.ManagersName || "";
      })
      .addCase(PSRreportpost.rejected, (state, action) => {
        state.PSRStatus = "Error";
        state.trackingLoading = false;
        state.PSRLoading = false;
        state.PSRData = [];
        state.PSRempTaskData = [];
        state.PSRprojectTaskData = [];
      })

      .addCase(RegGetData.pending, (state, action) => {
        state.RegGetData = {};
        state.getLoading = true;
      })
      .addCase(RegGetData.fulfilled, (state, action) => {
        state.RegGetData = action.payload.Data;
        state.getLoading = false;
      })
      .addCase(RegGetData.rejected, (state, action) => {
        state.RegGetData = {};
        state.getLoading = false;
      })


      .addCase(FilterGetData.pending, (state, action) => {
        state.filterGetData = {};
        state.filterGetLoading = true;
      })
      .addCase(FilterGetData.fulfilled, (state, action) => {
        state.filterGetData = action.payload.Data.Filters ? JSON.parse(action.payload.Data.Filters) : {};
        state.filterGetLoading = false;
      })
      .addCase(FilterGetData.rejected, (state, action) => {
        state.filterGetData = {};
        state.filterGetLoading = false;
      })
      .addCase(EmpMonthlyInv.pending, (state, action) => {
        state.EmpMonthlyInvoiceData = {};
        state.EmpMonthlyInvoiceLoading = true;
      })
      .addCase(EmpMonthlyInv.fulfilled, (state, action) => {
        state.EmpMonthlyInvoiceData = action.payload;
        state.EmpMonthlyInvoiceLoading = false;
      })
      .addCase(EmpMonthlyInv.rejected, (state, action) => {
        state.EmpMonthlyInvoiceData = {};
        state.EmpMonthlyInvoiceLoading = false;
      })
      .addCase(ProjectStatusReport.pending, (state, action) => {
        state.ProjectStatusReportData = {};
        state.ProjectStatusReportLoading = true;
      })
      .addCase(ProjectStatusReport.fulfilled, (state, action) => {
        state.ProjectStatusReportData = action.payload.Data;
        state.ProjectStatusReportLoading = false;
      })
      .addCase(ProjectStatusReport.rejected, (state, action) => {
        state.ProjectStatusReportData = {};
        state.ProjectStatusReportLoading = false;
      })
      .addCase(ProductCosting.pending, (state, action) => {
        state.ProductCostingData = {};
        state.ProductCostingLoading = true;
      })
      .addCase(ProductCosting.fulfilled, (state, action) => {
        state.ProductCostingData = action.payload;
        state.ProductCostingLoading = false;
      })
      .addCase(ProductCosting.rejected, (state, action) => {
        state.ProductCostingData = {};
        state.ProductCostingLoading = false;
      })
      .addCase(CostOverview.pending, (state, action) => {
        state.CostOverviewData = {};
        state.CostOverviewLoading = true;
      })
      .addCase(CostOverview.fulfilled, (state, action) => {
        state.CostOverviewData = action.payload;
        state.CostOverviewLoading = false;
      })
      .addCase(CostOverview.rejected, (state, action) => {
        state.CostOverviewData = {};
        state.CostOverviewLoading = false;
      })
      .addCase(CostTrend.pending, (state, action) => {
        state.CostTrendData = {};
        state.CostTrendLoading = true;
      })
      .addCase(CostTrend.fulfilled, (state, action) => {
        state.CostTrendData = action.payload;
        state.CostTrendLoading = false;
      })
      .addCase(CostTrend.rejected, (state, action) => {
        state.CostTrendData = {};
        state.CostTrendLoading = false;
      })
      .addCase(EmployeeOverrun.pending, (state, action) => {
        state.EmployeeOverrunData = {};
        state.EmployeeOverrunLoading = true;
      })
      .addCase(EmployeeOverrun.fulfilled, (state, action) => {
        state.EmployeeOverrunData = action.payload;
        state.EmployeeOverrunLoading = false;
      })
      .addCase(EmployeeOverrun.rejected, (state, action) => {
        state.EmployeeOverrunData = {};
        state.EmployeeOverrunLoading = false;
      })
      .addCase(ProjectManagerDashboard.pending, (state, action) => {
        state.ProjectManagerDashboardData = {};
        state.ProjectManagerDashboardLoading = true;
      })
      .addCase(ProjectManagerDashboard.fulfilled, (state, action) => {
        state.ProjectManagerDashboardData = action.payload;
        state.ProjectManagerDashboardLoading = false;
      })
      .addCase(ProjectManagerDashboard.rejected, (state, action) => {
        state.ProjectManagerDashboardData = {};
        state.ProjectManagerDashboardLoading = false;
      })

      //DesignationGet
      .addCase(DesignationGet.pending, (state, action) => {
        state.DesignationGetData = [];
        state.DesignationGetLoading = true;
      })
      .addCase(DesignationGet.fulfilled, (state, action) => {
        state.DesignationGetData = action.payload;
        state.DesignationGetLoading = false;
        state.DesignationGetStatus= "success";
      })
      .addCase(DesignationGet.rejected, (state, action) => {
        state.DesignationGetData = [];
        state.DesignationGetLoading = false;
        state.DesignationGetStatus= "error";
      })
      //TotalHrsOccupiedHrsGet
      .addCase(TotalHrsOccupiedHrsGet.pending, (state, action) => {
        state.TotalHrsOccupiedHrsGetData = [];
        state.TotalHrsOccupiedHrsGetLoading = true;
      })
      .addCase(TotalHrsOccupiedHrsGet.fulfilled, (state, action) => {
        state.TotalHrsOccupiedHrsGetData = action.payload;
        state.TotalHrsOccupiedHrsGetLoading = false;
        state.TotalHrsOccupiedHrsGetStatus= "success";
      })
      .addCase(TotalHrsOccupiedHrsGet.rejected, (state, action) => {
        state.TotalHrsOccupiedHrsGetData = [];
        state.TotalHrsOccupiedHrsGetLoading = false;
        state.TotalHrsOccupiedHrsGetStatus= "error";
      })
      //ProjectSplitupHrsList
      .addCase(ProjectSplitupHrsList.pending, (state, action) => {
        state.ProjectSplitupHrsListData = [];
        state.ProjectSplitupHrsListLoading = true;
      })
      .addCase(ProjectSplitupHrsList.fulfilled, (state, action) => {
        state.ProjectSplitupHrsListData = action.payload;
        state.ProjectSplitupHrsListLoading = false;
        state.ProjectSplitupHrsListStatus= "success";
      })
      .addCase(ProjectSplitupHrsList.rejected, (state, action) => {
        state.ProjectSplitupHrsListData = {};
        state.ProjectSplitupHrsListLoading = false;
        state.ProjectSplitupHrsListStatus= "error";
      })
      //EmployeeMapController
      .addCase(EmployeeMapController.pending, (state, action) => {
        state.EmployeeMapControllerData = {};
        state.EmployeeMapControllerLoading = true;
      })
      .addCase(EmployeeMapController.fulfilled, (state, action) => {
        state.EmployeeMapControllerData = action.payload;
        state.EmployeeMapControllerLoading = false;
        state.EmployeeMapControllerStatus= "success";
      })
      .addCase(EmployeeMapController.rejected, (state, action) => {
        state.EmployeeMapControllerData = [];
        state.EmployeeMapControllerLoading = false;
        state.EmployeeMapControllerStatus= "error";
      })
      //EmployeeAddController
      .addCase(EmployeeAddController.pending, (state, action) => {
        state.EmployeeAddControllerData = {};
        state.EmployeeAddControllerLoading = true;
      })
      .addCase(EmployeeAddController.fulfilled, (state, action) => {
        state.EmployeeAddControllerData = action.payload;
        state.EmployeeAddControllerLoading = false;
        state.EmployeeAddControllerStatus= "success";
      })
      .addCase(EmployeeAddController.rejected, (state, action) => {
        state.EmployeeAddControllerData = [];
        state.EmployeeAddControllerLoading = false;
        state.EmployeeAddControllerStatus= "error";
      })
      .addCase(ProjectStatusReportBarChart.pending, (state, action) => {
        state.PSRBarChartData = {};
        state.PSRBarChartLoading = true;
      })
      .addCase(ProjectStatusReportBarChart.fulfilled, (state, action) => {
        state.PSRBarChartData = action.payload.Data;
        state.PSRBarChartLoading = false;
      })
      .addCase(ProjectStatusReportBarChart.rejected, (state, action) => {
        state.PSRBarChartData = {};
        state.PSRBarChartLoading = false;
      })

      //HOMEWORK_TEACHER_GET
      .addCase(HomeworkTeachGet.pending, (state, action) => {
        state.HWteachstatus = "idle";
        state.HWteachloading = true;
      })
      .addCase(HomeworkTeachGet.fulfilled, (state, action) => {
        console.log(action.payload, "--action.payload");

        state.HWteachstatus = "success";
        state.HWteachloading = false;
        state.HWteachdata = action.payload;

      })
      .addCase(HomeworkTeachGet.rejected, (state, action) => {
        state.HWteachstatus = "Error";
        state.HWteachloading = false;
      })

      //HOMEWORK_EVALUATION_GET
      .addCase(HomeworkEvalGet.pending, (state, action) => {
        state.HWevalstatus = "idle";
        state.HWevalloading = true;
      })
      .addCase(HomeworkEvalGet.fulfilled, (state, action) => {
        state.HWevalstatus = "success";
        state.HWevalloading = false;
        state.HWevaldata = action.payload;

      })
      .addCase(HomeworkEvalGet.rejected, (state, action) => {
        state.HWevalstatus = "Error";
        state.HWevalloading = false;
      })
      //HOMEWORK_ANALYTICS_CHART_GET

      .addCase(HomeworkEvalAnalyticsGet.pending, (state, action) => {
        state.HWAnalyticsstatus = "idle";
        state.HWAnalyticsloading = true;
        state.HWAnalyticsdata = {};
      })
      .addCase(HomeworkEvalAnalyticsGet.fulfilled, (state, action) => {
        state.HWAnalyticsstatus = "success";
        state.HWAnalyticsloading = false;
        state.HWAnalyticsdata = action.payload || [];
        console.log(action.payload, "---action.payload in Hwanalyticsdata");

      })
      .addCase(HomeworkEvalAnalyticsGet.rejected, (state, action) => {
        state.HWAnalyticsstatus = "Error";
        state.HWAnalyticsloading = false;
      })
       //PAYSLIP - GET
      .addCase(paySlipGet.pending, (state, action) => {
        state.paySlipstatus = "idle";
        state.paySliploading = true;
      })
      .addCase(paySlipGet.fulfilled, (state, action) => {
        state.paySlipstatus = "success";
        state.paySliploading = false;
        state.paySlipdata = action.payload.data
          ? action.payload.data
          : [];
      })
      .addCase(paySlipGet.rejected, (state, action) => {
        state.paySlipstatus = "Error";
        state.paySliploading = false;
      });

  },
});

// Destructure and export the plain action creators
export const {
  pending,
  errored,
  userGroupUpdate,
  Success,
  stockSuccess,
  stockReqSuccess,
  resetTrackingData,
  setFilterGetData,
  resetProjectStatusReport,
  resetPSRBarChart,
  setRepaymentRows,
  resetProductCostingBar,
  resetCostOverviewBar,
  resetCostTrendBar,
  resetTimeSheetAttendance,
  resetEmployeeOverrunBar
  // packingListCarton
} = getApiSlice.actions;

export default getApiSlice.reducer;

export const fetchApidata =
  (AccessID, Action, idata) => (dispatch, getState) => {
    //  alert(Action);

    var url = store.getState().globalurl.apiUrl;
    var data = {
      accessid: AccessID,
      action: Action,
      recid: idata,
    };

    console.log("🚀 ~ file: Formapireducer.js:794 ~ JSON.stringify(data):", JSON.stringify(data))
    dispatch(pending());
    axios
      .post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })

      .then((response) => {
        console.log(
          "🚀 ~ file: Formapireducer.js:413 ~ .then ~ response:",
          response
        );
        console.log("response data" + JSON.stringify(response.data));
        var apidata = response.data;
        // console.log("🚀 ~ file: Formapireducer.js:415 ~ .then ~ response.data:", response.data)

        //     apidata=eval(apidata);
        //    console.log("apidatastatus"+typeof(response.data))
        if (apidata.Status == "Y") {
          // console.log("apidata" + JSON.stringify(apidata.Data));

          if (apidata.Data.Disable == "Y") {
            apidata.Data.Disable = true;
          } else apidata.Data.Disable = false;
          if (AccessID == "TR014") {
            if (apidata.Data.Process == "Y") {
              apidata.Data.Process = true;
            } else apidata.Data.Process = false;
          }
          if (AccessID == "TR014") {
            if (apidata.Data.Regularslno == "Y") {
              apidata.Data.Regularslno = true;
            } else apidata.Data.Regularslno = false;
          }
          if (AccessID == "TR003") {
            if (apidata.Data.Hidevisible == "Y") {
              apidata.Data.Hidevisible = true;
            } else apidata.Data.Hidevisible = false;
          }
          if (AccessID == "TR004") {
            if (apidata.Data.Rawmaterial == "Y") {
              apidata.Data.Rawmaterial = true;
            } else apidata.Data.Rawmaterial = false;

            if (apidata.Data.Consumable == "Y") {
              apidata.Data.Consumable = true;
            } else apidata.Data.Consumable = false;

            if (apidata.Data.Sellable == "Y") {
              apidata.Data.Sellable = true;
            } else apidata.Data.Sellable = false;
            if (apidata.Data.DesignApp == "Y") {
              apidata.Data.DesignApp = true;
            } else apidata.Data.DesignApp = false;
          }

          if (AccessID == "TR010") {
            if (apidata.Data.ForiegnAgentFlag == "Y") {
              apidata.Data.ForiegnAgentFlag = true;
            } else apidata.Data.ForiegnAgentFlag = false;

            if (apidata.Data.LocalAgentFlag == "Y") {
              apidata.Data.LocalAgentFlag = true;
            } else apidata.Data.LocalAgentFlag = false;
          }
          if (AccessID == "TR021") {
            if (apidata.Data.Duration == "Y") {
              apidata.Data.Duration = true;
            } else apidata.Data.Duration = false;

            if (apidata.Data.Incharge == "Y") {
              apidata.Data.Incharge = true;
            } else apidata.Data.Incharge = false;
          }
          if (AccessID == "TR009") {
            if (apidata.Data.Jobwork == "Y") {
              apidata.Data.Jobwork = true;
            } else apidata.Data.Jobwork = false;


          }
          if (AccessID == "TR110") {
            if (apidata.Data.Sameplist == "Y") {
              apidata.Data.Sameplist = true;
            } else apidata.Data.Sameplist = false;


          }
          if (AccessID == "TR085") {
            if (apidata.Data.Productcost == "Y") {
              apidata.Data.Productcost = true;
            } else apidata.Data.Productcost = false;
          }
          dispatch(
            Success({
              action: Action,
              Status: apidata.Status,
              apiResponse: apidata.Data,
              Msg: "",
            })
          );
        } else {
          dispatch(
            Success({
              action: Action,
              Status: apidata.Status,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(errored);
        //dispatch(errored({"action":Action,"Status":apidata.Status,"apiResponse":apidata.Data,"Msg":""}))
      });
  };

export function postApidata(AccessID, Action, idata) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);

      const datawait = dispatch(
        Success({
          action: Action,
          Status: success.data.Status,
          // data:success.
          apiResponse: {},
          Msg: success.data.Msg,
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      console.log("---", idata);
      var isCompanyID = Object.hasOwn(idata, 'CompanyID');
      var isFinyear = Object.hasOwn(idata, 'Finyear');
      const Finyear = sessionStorage.getItem("YearRecorid");
      const CompanyID = sessionStorage.getItem("compID");
      if (!isCompanyID && AccessID !== 'TR030' && AccessID !== 'TR076') {
        idata = {
          ...idata,
          CompanyID,
        }
      }
      if (!isFinyear && AccessID !== 'TR030' && AccessID !== 'TR076') {
        idata = {
          ...idata,
          Finyear,
        }
      }
      console.log("🚀 ~ file: Formapireducer.js:734 ~ return ~ idata:", idata)
      var url = store.getState().globalurl.apiUrl;
      var data = {
        accessid: AccessID,
        action: Action,
        data: idata,
      };
      dispatch(pending());
      console.log("postdata" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      console.log(
        "🚀 ~ file: Formapireducer.js:335 ~ return ~ success:",
        success
      );
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function proformainvApidata(
  RecordID,
  ProfoInvoiceNO,
  ProfoInvoiceDate,
  parentID,
  YearID
) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);

      const datawait = dispatch(
        Success({
          action: "",
          Status: success.data.Status,
          apiResponse: {},
          Msg: success.data.Msg,
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.proformainvUrl;
      const Finyear = sessionStorage.getItem("YearRecorid");
      const CompanyID = sessionStorage.getItem("compID");
      var data = {
        RecordID: RecordID,
        ProfoInvoiceNO: ProfoInvoiceNO,
        ProfoInvoiceDate: ProfoInvoiceDate,
        type: parentID,
        YearID: YearID,
        CompanyID,
        Finyear
      };
      dispatch(pending());
      console.log("postdata" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function finalinvApidata(
  RecordID,
  FinalInvoiceNO,
  FinalInvoiceDate,
  parentID,
  YearID
) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);

      const datawait = dispatch(
        Success({
          action: "",
          Status: success.data.Status,
          apiResponse: {},
          Msg: success.data.Msg,
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      const Finyear = sessionStorage.getItem("YearRecorid");
      const CompanyID = sessionStorage.getItem("compID");
      var url = store.getState().globalurl.finalinvUrl;
      var data = {
        RecordID: RecordID,
        FinalInvoiceNO: FinalInvoiceNO,
        FinalInvoiceDate: FinalInvoiceDate,
        type: parentID,
        YearID: YearID,
        CompanyID,
        Finyear
      };
      dispatch(pending());
      console.log("postdata" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function postApidatawol(AccessID, Action, idata) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);

      const datawait = dispatch(
        Success({
          action: Action,
          Status: success.data.Status,
          apiResponse: success.data.Recid,
          Msg: success.data.Msg,
          // Data: idata
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.apiUrl;
      var data = {
        accessid: AccessID,
        action: Action,
        data: idata,
      };
      dispatch(pending());
      console.log("postdata" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      console.log(
        "🚀 ~ file: Formapireducer.js:475 ~ return ~ success:",
        success
      );
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function fetchRecIDApidata(AccessID, Action, idata) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);
      const datawait = dispatch(
        Success({
          action: Action,
          Status: success.data.Status,
          apiResponse: success.data.Data,
          Msg: "",
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.apiUrl;
      var data = {
        accessid: AccessID,
        action: Action,
        recid: idata,
      };
      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function VersioningFetch(recid) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);
      const datawait = dispatch(
        Success({
          action: "get",
          Status: success.data.Status,
          apiResponse: success.data.Data,
          Msg: "",
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.commonUrl;
      var data = {
        recid: recid,
        action: "get",
        accessid: "",
      };

      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}
// supplier Tracking
export function supplierTrackFetch(SupplierID) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + JSON.stringify(success));
      console.log("2---" + JSON.stringify(success.data.Data));
      const datawait = dispatch(
        Success({
          action: "get",
          Status: success.data.Status,
          apiResponse: success.data.Data,
          Msg: "",
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.supplierTrackUrl;
      var data = { SupplierID: SupplierID };

      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function TrackingFetchfn(MaterialID, Type) {
  return async (dispatch) => {
    function onSuccess(success) {
      // console.log("2---" +JSON.stringify(success));
      //  console.log("2---" + JSON.stringify(success.data));
      const datawait = dispatch(
        Success({
          // action: "get",
          // Status: success.data.Status,
          apiResponse: success.data,
          // Msg: "",
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.trackingUrl;
      var data = {
        MaterialID: MaterialID,
        Type: Type,

      };

      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}



export function bomCopyApiData(recid, type) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);
      const datawait = dispatch(
        Success({
          action: "get",
          Status: success.data.Status,
          apiResponse: {},
          Msg: "",
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.bomCopyUrl;
      var data = {
        BhprdRecordID: recid,
      };

      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function bomFetchapiData(AccessID, Action, idata) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);
      const datawait = dispatch(
        Success({
          action: Action,
          Status: success.data.Status,
          apiResponse: success.data.Data,
          Msg: "",
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.bomHeaderUrl;

      var data = {
        recid: AccessID,
        action: Action,
        ProductID: idata,
      };
      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function stockFetchapiData(AccessID, Action, idata) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + success.data.Status);
      const datawait = dispatch(
        Success({
          action: Action,
          Status: success.data.Status,
          apiResponse: success.data.Data,
          Msg: "",
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.apiUrl;

      var data = {
        accessid: AccessID,
        action: Action,
        recid: idata,
      };
      dispatch(pending());
      console.log("get" + JSON.stringify(data));
      const success = await axios.post(url, data, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4ODA2MTV9.uVL-s9M7nOPBH01dT1bpQbu0xbwXK4JT7HQo8h87t50",
        },
      });
      console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}



export const stockApidata =
  (AccessID, recid, Type, Year) => (dispatch, getState) => {
    //  alert(Action);

    var url = store.getState().globalurl.stockUrl;
    var data = {
      Query: {
        accessid: AccessID,
        recid: recid,
        Type: Type,
        Year: Year,
      },
    };
    data = JSON.stringify(data);
    console.log(data);
    dispatch(pending());
    axios
      .get(url, {
        params: {
          data: data,
        },

        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })

      .then((response) => {
        console.log("response data" + JSON.stringify(response.data));
        var apidata = response.data;

        //     apidata=eval(apidata);
        //    console.log("apidatastatus"+typeof(response.data))
        if (apidata.Status == "Y") {
          console.log("apidata" + JSON.stringify(apidata.Data));

          dispatch(
            Success({
              action: "get",
              Status: apidata.Status,
              apiResponse: apidata.Data,
              Msg: "",
            })
          );
        } else {
          dispatch(
            Success({
              action: "get",
              Status: apidata.Status,
              apiResponse: apidata.Data,
              Msg: "",
            })
          );
        }
      })
      .catch((error) => {
        dispatch(errored);
        //dispatch(errored({"action":Action,"Status":apidata.Status,"apiResponse":apidata.Data,"Msg":""}))
      });
  };

export const batchApidata =
  (productID, ProformaID, bomID) => (dispatch, getState) => {
    var url = store.getState().globalurl.batchUrl;
    var data = {
      Query: {
        ProfomID: ProformaID,
        ProductID: productID,
        BomHeader: bomID,
      },
    };
    data = JSON.stringify(data);
    console.log(data);
    dispatch(pending());
    axios
      .get(url, {
        params: {
          data: data,
        },

        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      })

      .then((response) => {
        console.log("response data" + JSON.stringify(response.data));
        var apidata = response.data;

        //     apidata=eval(apidata);
        //    console.log("apidatastatus"+typeof(response.data))
        if (apidata.Status == "Y") {
          console.log("apidata" + JSON.stringify(apidata.Data));

          dispatch(
            Success({
              action: "get",
              Status: apidata.Status,
              apiResponse: apidata.Data,
              Msg: "",
            })
          );
        } else {
          dispatch(
            Success({
              action: "get",
              Status: apidata.Status,
              apiResponse: apidata.Data,
              Msg: "",
            })
          );
        }
      })
      .catch((error) => {
        dispatch(errored);
        //dispatch(errored({"action":Action,"Status":apidata.Status,"apiResponse":apidata.Data,"Msg":""}))
      });
  };

export function orderFetchapiData(name) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("Inside Stock-" + success.data.Status);
      const datawait = dispatch(
        Success({
          Status: success.data.Status,
          apiResponse: success.data.Data,
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.orderUrl;

      var data = {
        Query: {
          Name: name,
        },
      };
      data = JSON.stringify(data);
      console.log("---" + url);
      dispatch(pending());

      const success = await axios.get(url, {
        params: {
          data: data,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function stockvalueFetchapiData(name) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("Inside Stock-" + success.data.Status);
      const datawait = dispatch(
        stockSuccess({
          stockapiResponse: success.data.Data,
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.productUrl;

      var data = {
        Query: {
          Name: name,
        },
      };
      data = JSON.stringify(data);
      console.log("---" + url);
      dispatch(pending());

      const success = await axios.get(url, {
        params: {
          data: data,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function MaterialTrackingFetchData(RecordID, Type) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("chartData---" + JSON.stringify(success));
      const datawait = dispatch(
        stockReqSuccess({
          stockReqapiResponse: success.data.Data,
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.materialsTrackingUrl;

      var data = {
        Query: {
          RecordID: RecordID,
          Type: Type
        },
      };
      data = JSON.stringify(data);
      console.log("---" + data);
      dispatch(pending());

      const success = await axios.get(url, {
        params: {
          data: data,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("chart Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}



export function supplierTrackingFetchData(RecordID) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("Inside Stock-" + JSON.stringify(success));
      const datawait = dispatch(
        stockReqSuccess({
          stockReqapiResponse: success.data.Data,
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.supplytrackingUrl;

      var data = {
        Query: {
          RecordID: RecordID,
        },
      };
      data = JSON.stringify(data);
      // console.log("---"+url);
      dispatch(pending());

      const success = await axios.get(url, {
        params: {
          data: data,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function stockRequirementFetchapiData(name) {
  return async (dispatch) => {
    function onSuccess(success) {
      // console.log("Inside Stock-" + success.data.Status);
      const datawait = dispatch(
        stockReqSuccess({
          stockReqapiResponse: success.data.Data,
        })
      );
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.stockReqUrl;

      var data = {
        Query: {
          Name: name,
        },
      };
      data = JSON.stringify(data);
      console.log("🚀 ~ file: Formapireducer.js:1353 ~ return ~ data:", data)
      // console.log("---"+url);
      dispatch(pending());

      const success = await axios.get(url, {
        params: {
          data: data,
        },
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
        },
      });
      // console.log("Response---" + JSON.stringify(success));
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}
export const empAttendance = createAsyncThunk(
  "employee/Payrollattendance",
  async ({ data }) => {

    var url = store.getState().globalurl.payrollattendanceUrl;
    // var url = store.getState().globalurl.employeeattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const RepaymentHDget = createAsyncThunk(
  "employee/RepaymentHDget",
  async (data) => {

    const url = store.getState().globalurl.RepaymentHDgetController;

    console.log("Request Data:", data);

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    console.log("API Response:", response);

    return response.data;
  }
);
// export const empcontractcheck = createAsyncThunk(
//   "empcontractcheck/CheckcontractFlag",
//   async ({ data }) => {

//     var url = store.getState().globalurl.CheckEmpcontractwithFlag;

//     console.log("get" + JSON.stringify(data));
//     console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
//     const response = await axios.post(url, data, {
//       headers: {
//         Authorization:
//           "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
//       },
//     });
//     console.log(
//       "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
//       response
//     );
//     return response.data;
//   }
// );
export const empinvoicecheck = createAsyncThunk(
  "empinvoicecheck/CheckinvoiceFlag",
  async ({ data }) => {

    var url = store.getState().globalurl.Invoicegetempattendance;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const timeSheet = createAsyncThunk(
  "timeSheet/timeSheetattendance",
  async ({ data }) => {

    var url = store.getState().globalurl.timesheetattendanceUrl;
    // var url = store.getState().globalurl.employeeattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);


export const timeSheetreport = createAsyncThunk(
  "timeSheet/timeSheetattendance",
  async ({ data }) => {

    var url = store.getState().globalurl.timesheetreportattendanceUrl;
    // var url = store.getState().globalurl.employeeattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

//Teacher_Get
export const Teacherget = createAsyncThunk(
  "Academic/Teacher_Get",
  async ({ data }) => {

    var url = store.getState().globalurl.TeacherGetUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const TeacherInvoiceget = createAsyncThunk(
  "Academic/Teacher_Invoice_Get",
  async ({ data }) => {

    var url = store.getState().globalurl.TeacherinvoiceGetUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
//PAR REPORT POST
export const PSRreportpost = createAsyncThunk(
  "timeSheet/PSR Report",
  async ({ data }) => {

    var url = store.getState().globalurl.PSRreportattendanceUrl;
    // var url = store.getState().globalurl.employeeattendanceUrl;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const userActivityLog = createAsyncThunk(
  "activity/log",
  async ({ RecordID, UserID, CompanyID, AccessID, Activity, Type }) => {
    const url = store.getState().globalurl.UserActivityUrl;

    const payload = {
      RecordID,
      UserID,
      CompanyID,
      AccessID,
      Activity,
      Type
    };

    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ...",
      },
    });

    return response.data;
  }
);

export const EmpMonthlyInv = createAsyncThunk(
  "EmpMonthlyInv/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.CheckEmpcontractwithFlag;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const ProjectStatusReport = createAsyncThunk(
  "ProjectStatusReport/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.ProjectStatusReport;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);


export const ProjectStatusReportBarChart = createAsyncThunk(
  "ProjectStatusReportBarChart/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.ProjectStatusReportBarChart;

    console.log("get" + JSON.stringify(data));
    console.log("🚀 ~ file: Formapireducer.js:26 ~ data:", data);
    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);

export const ProductCosting = createAsyncThunk(
  "ProductCosting/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.ProductCosting;

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const CostOverview = createAsyncThunk(
  "CostOverview/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.CostOverview;

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const CostTrend = createAsyncThunk(
  "CostTrend/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.CostTrend;

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const EmployeeOverrun = createAsyncThunk(
  "EmployeeOverrunChart/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.EmployeeOverrun;

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const ProjectManagerDashboard = createAsyncThunk(
  "ProjectManagerDashboard/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.ProjectManagerDashboard;

    const response = await axios.post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const TimetableProcessController = createAsyncThunk(
  "TimetableProcess/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.TimetableProcessController;

    const payload =
    {
      HeaderID: data.HeaderID,
      TeacherID: data.TeacherID,
      Process: data.Process
    }
    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const TeacherOccupancyget = createAsyncThunk(
  "Mgr_Desk/TeacherOccupancy",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const url = getState().globalurl.TeacherOccupancy;

      const response = await axios.post(url, payload, {
        headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
      });

      console.log("✅ API RESPONSE:", response.data);

      return response.data;
    } catch (error) {
      console.error("API ERROR:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const AssessmentVerifyUpdateController = createAsyncThunk(
  "AssessmentVerifyUpdateController/post",
  async ({ idata }) => {
    const url = store.getState().globalurl.AssessmentVerifyUpdateController;

    const payload = {
      ...idata
    };

    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ...",
      },
    });

    return response.data;
  }
);
export const EmergencyNotificationPost = createAsyncThunk(
  "EmergencyNotificationPost/post",
  async ({ CompanyID,EmployeeID,RecordID, IsRead}) => {
    const url = store.getState().globalurl.EmergencyNotificationPost;

    const payload = {
      CompanyID,
      EmployeeID,
      RecordID,
      IsRead
    };

    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  }
);

export const AssessmentEvaluateController = createAsyncThunk(
  "AssessmentEvaluateController/post",
  async ({ idata }) => {
    const url = store.getState().globalurl.AssessmentEvaluateController;

    const payload = {
      ...idata
    };

    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ...",
      },
    });

    return response.data;
  }
);

export const DashboardVisualLeaveApproval = createAsyncThunk(
  "DashboardVisualLeaveApproval/post",
  async ({ idata }) => {
    const url = store.getState().globalurl.DashboardVisualLeaveApproval;

    const payload = {
      ...idata
    };

    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });

    return response.data;
  }
);

export const DesignationGet = createAsyncThunk(
  "DesignationGet/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.DesignationGet;

    const payload =
    {
      CompanyID: data.CompanyID,
      ProjectID: data.ProjectID,
    }
    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const TotalHrsOccupiedHrsGet = createAsyncThunk(
  "TotalHrsOccupiedHrsGet/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.TotalHrsOccupiedHrsGet;

    const payload =
    {
      DesignationID: data.DesignationID,
      ProjectID: data.ProjectID,
    }
    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const ProjectSplitupHrsList = createAsyncThunk(
  "ProjectSplitupHrsList/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.ProjectSplitupHrsList;

    const payload =
    {
      EmployeeID: data.EmployeeID,
      ProjectID: data.ProjectID,
    }
    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const EmployeeMapController = createAsyncThunk(
  "EmployeeMapController/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.EmployeeMapController;

    const payload =
    {
      EmployeeID: data.EmployeeID,
      ProjectID: data.ProjectID,
      InchargeID: data.InchargeID,
      Action: data.Action
    }
    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);
export const EmployeeAddController = createAsyncThunk(
  "EmployeeAddController/Get",
  async ({ data }) => {
    var url = store.getState().globalurl.ProjectTeamsMembersGet;

    const payload =
    {
      ProjectID: data.ProjectID,
    }
    const response = await axios.post(url, payload, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log(
      "🚀 ~ file: newFormApiReducer.js:27 ~ fetchData ~ response:",
      response
    );
    return response.data;
  }
);